import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import {
  BlockCardResponse,
  CardholDerdetailPayload,
  CardholDerdetailResponse,
  DownloadStatementExcelResponse,
  GetProductListResponse,
  SmsNotificationPayload,
  SmsNotificationResponse,
  StatementPayload,
  StatementResponse,
  StopCardPayload,
  TransferAmountPayload,
  TransferAmountResponse,
  WalletStatementResponse,
  WalletToCardOtpPayload,
  WalletToCardOtpVerifyPayload
} from '../models/cardholder';
import { Response } from '../models/api-response'

@Injectable({
  providedIn: 'root'
})
export class CardholderService {

  constructor(private dataService: DataService) { }

  GetProductLists() {
    return this.dataService.newpost<GetProductListResponse>('/getproductlist', true)
  }
  CardholDerdetail(data: CardholDerdetailPayload) {
    return this.dataService.newpost<CardholDerdetailResponse>('/cardholderdetail', data)
  }


  StopCard(data: StopCardPayload) {
    return this.dataService.newpost<BlockCardResponse>('/stopcard', data)
  }


  StopCardList() {
    return this.dataService.newgetData<any>('/cardblockreason', true)
  }

  updateSmsNotification(data: SmsNotificationPayload) {
    return this.dataService.newpost<SmsNotificationResponse>('/updatesmsnotification', data)
  }


  Statements(data: StatementPayload) {
    return this.dataService.newpost<StatementResponse>('/statement', data)
  }

  downloadCardStatementExcel(data: StatementPayload) {
    return this.dataService.newpost<DownloadStatementExcelResponse>('/statement/excel', data)
  }
  downloadCardStatementPdf(data: StatementPayload) {
    return this.dataService.newpost<DownloadStatementExcelResponse>('/statement/pdf', data)
  }

  walletToCardOtp(data: WalletToCardOtpPayload) {
    return this.dataService.newpost<Response>('/wallettocardotp', data)
  }


  walletCardOtpVerify(data: WalletToCardOtpVerifyPayload) {
    return this.dataService.newpost<Response>('/walletcardotpverify', data)
  }


  transferAmount(data: TransferAmountPayload) {
    return this.dataService.newpost<TransferAmountResponse>('/loadcardfromwallet', data)
  }


  walletStatement(result: StatementPayload) {
    return this.dataService.newpost<WalletStatementResponse>('/walletstatement', result);
  }
  downloadWalletStatementExcel(result: any) {
    return this.dataService.post('/walletstatement/excel', result);
  }
  downloadWalletStatementPdf(result: any) {
    return this.dataService.post('/walletstatement/pdf', result);
  }
}